/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateClassroomDisciplineViewModel } from "../types/CreateClassroomDisciplineViewModel.ts";
import { eChatTypeSchema } from "./eChatTypeSchema.ts";
import { eClassRoomDisciplinesStatusSchema } from "./eClassRoomDisciplinesStatusSchema.ts";
import { eClassTypeSchema } from "./eClassTypeSchema.ts";

export const createClassroomDisciplineViewModelSchema = z.object({
  disciplinesId: z.number().int().nullish(),
  classroomId: z.number().int().nullish(),
  companyId: z.number().int().nullish(),
  classModuleId: z.number().int().nullish(),
  classModuleIndex: z.optional(z.number().int()),
  groupId: z.number().int().nullish(),
  monographEventId: z.number().int().nullish(),
  dateStart: z.optional(z.string().datetime()),
  dateFinish: z.optional(z.string().datetime()),
  fixedDate: z.boolean().nullish(),
  type: z.optional(
    z.lazy(() => eClassTypeSchema).describe("1 = Normal | 2 = OnDemand | "),
  ),
  duration: z.number().int().nullish(),
  recurrenceClassroomDisciplineId: z.number().int().nullish(),
  status: z.optional(
    z
      .lazy(() => eClassRoomDisciplinesStatusSchema)
      .describe("1 = Planned | 2 = Finished | 3 = Canceled | 4 = Confirmed | "),
  ),
  sendNotification: z.boolean().nullish(),
  classAvailable: z.optional(z.boolean()),
  faceTest: z.optional(z.boolean()),
  isRecovery: z.optional(z.boolean()),
  hasContent: z.optional(z.boolean()),
  isExtraClass: z.optional(z.boolean()),
  computeGrade: z.optional(z.boolean()),
  computeAttendance: z.optional(z.boolean()),
  forceProcessGrade: z.optional(z.boolean()),
  complementaryActivity: z.optional(z.boolean()),
  isContingency: z.optional(z.boolean()),
  isPreExamClassroom: z.optional(z.boolean()),
  isOpeningClass: z.optional(z.boolean()),
  isVisualizationAttendance: z.optional(z.boolean()),
  isManuallyAdded: z.optional(z.boolean()),
  isIntroductoryModule: z.optional(z.boolean()),
  planningWithExam: z.optional(z.boolean()),
  isScholarshipProcessTest: z.optional(z.boolean()),
  isEntranceProcessTest: z.optional(z.boolean()),
  useTeacherThumbnail: z.optional(z.boolean()),
  evaluationWeight: z.number().nullish(),
  thumbnail: z.string().nullish(),
  thumbnailUrl: z.string().nullish(),
  slides: z.optional(z.number().int()),
  chatEmbedType: z.optional(
    z
      .lazy(() => eChatTypeSchema)
      .describe(
        "1 = UseArenaChat | 2 = Manual | 3 = UseGetStream | 4 = UseDeadSimpleChat | 5 = UseMoveChat | ",
      ),
  ),
  chatEmbedCode: z.string().nullish(),
  moveChatRoomId: z.string().nullish(),
  getStreamChatId: z.string().nullish(),
  arenaChatId: z.string().nullish(),
  arenaChatSlug: z.string().nullish(),
  deadSimpleChatRoomId: z.string().nullish(),
  enableChatTranslation: z.boolean().nullish(),
  useArenaChat: z.optional(z.boolean()),
  useMoveQA: z.optional(z.boolean()),
  useMoveClass: z.optional(z.boolean()),
  linkVirtualRoom: z.string().nullish(),
  classStudentIds: z.array(z.number().int()).nullish(),
  conflictsChecked: z.optional(z.boolean()),
}) as unknown as ToZod<CreateClassroomDisciplineViewModel>;
